import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import { useSelector } from 'react-redux'

import { CustomWindow, Table } from '../../../../../components'
import mapWithRelationship from '../../../../../lib/detectRelationship'
import { selectRelateds } from '../../../../../redux/selectors/relateds'
import {
  formatCurrency,
  formatDocument,
  hashObject,
  isCypheredDocument,
  isPending,
  onlyNumbers
} from '../../../../../utils'

const { SearchBar } = Search

export default function AutoInfracao ({ data, error, loaded }) {
  const relateds = useSelector(selectRelateds)

  const name = 'bandeiraAmarela.autoInfracao'
  const title = 'Infrações'

  if (isPending({ error, loaded })) {
    return (
      <CustomWindow title={title} name={name}>
        <div />
      </CustomWindow>
    )
  }

  if (error) {
    return (
      <CustomWindow title={title} name={name} defaultOpen>
        <div>Ops! Aconteceu um erro ao carregar infrações</div>
      </CustomWindow>
    )
  }

  return (
    <CustomWindow title={title} name={name}>
      <ToolkitProvider
        keyField='id'
        search
        columns={[
          { dataField: 'nomeInfrator', text: 'Nome' },
          {
            dataField: 'relationship',
            text: 'Grau'
          },
          { dataField: 'document', text: 'CPF / CNPJ', searchable: false },
          { dataField: 'rawDocument', text: '', hidden: true },
          { dataField: 'date', text: 'Data da infração' },
          { dataField: 'valAutoInfracao', text: 'Valor da multa' },
          { dataField: 'desInfracao', text: 'Detalhes' }
        ].map(item => ({ ...item, align: 'center', headerAlign: 'center' }))}
        data={mapWithRelationship({
          array: data || [],
          documentKey: 'cpfCnpjInfrator',
          nameKey: 'nomeInfrator',
          relateds
        }).map(item => {
          const id = hashObject(item)
          return {
            ...item,
            id,
            valAutoInfracao:
              typeof item.valAutoInfracao === 'string'
                ? formatCurrency(parseFloat(item.valAutoInfracao))
                : undefined,
            rawDocument: item.cpfCnpjInfrator,
            date: item.datHoraAutoInfracao.includes(':')
              ? item.datHoraAutoInfracao.split(' ')[0]
              : item.datHoraAutoInfracao,
            document: isCypheredDocument(item.cpfCnpjInfrator) ? (
              item.cpfCnpjInfrator
            ) : (
              <a
                href={`?documento=${onlyNumbers(item.cpfCnpjInfrator)}`}
                target='_blank'
                rel='noopener noreferrer'
              >
                {formatDocument(item.cpfCnpjInfrator)}
              </a>
            )
          }
        })}
      >
        {props => (
          <>
            <div className='row'>
              <div className='col-12 text-lg-right'>
                <SearchBar {...props.searchProps} placeholder='Pesquisar' />
              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                <Table enablePagination {...props.baseProps} />
              </div>
            </div>
          </>
        )}
      </ToolkitProvider>
    </CustomWindow>
  )
}
